import { Container, Row, Col, Alert, Button } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';

export default function Start() {
    const navigate = useNavigate();
    return (
        <Container className='mt-2 py-5'>
            <Row>
                <Col xs="12" style={{ fontSize: 14, lineHeight: 2, color: '#646464' }}>
                    <h4 style={{ color: '#223e7d' }} className='text-center fw-bold'>روش تكمیل اطلاعات تامین‌کنندگان و پیمانکاران در سامانه مدیریت بررسی منابع</h4>
                    <div className='mt-4'>
                        <Alert variant={'warning'}>
                            لطفا پرسشنامه را با توجه به توضیحات زیر تکمیل نموده و در صورت نیاز با شماره‌ 3133-058 داخلی 2549 (عبدالرضا روستا) تماس حاصل فرمایید.
                        </Alert>
                    </div>
                    <div>
                        قابل توجه کلیه موسسات، شرکت‌ها، فروشگاه‌ها و پیمانكاران داوطلب تامین‌کننده کالا و خدمات برای شرکت پتروشیمی خراسان
                        با سلام
                        ضمن اظهار خرسندی از شروع همکاری، به اطلاع می‌رساند با توجه به ایجاد سامانه تکمیل اطلاعات و مستندات مورد نیاز جهت ارتباط، تعامل و مشارکت در تامین کالا و خدمات این شرکت، روش بهرمندی از سامانه مورد نظر به شرح ذیل اعلام می‌گردد. لطفا متن پیش رو را به دقت مطالعه نموده و پس از ورود به سامانه، گزینه‌های مورد درخواست را تکمیل فرمایید.
                        <ul>
                            <li>جهت ورود به سامانه فقط از مرورگر فایر فاكس استفاده شود</li>
                            <li>مسئولیت صحت اطلاعات و مستندات ارایه شده به عهده آن فروشگاه / شركت می باشد.</li>
                            <li>ارایه یك شماره تلفن همراه بالاترین مقام اجرایی الزامی است كه این شماره به عنوان شماره پیش فرض در كانال رسمی ارتباط پیامكی در نظر گرفته خواهد شد. لذا هر گونه تغییر و تحول احتمالی در شماره مذكور (در هر شرایط و به هر علت) فقط با درخواست كتبی بالاترین مقام اجرایی شرکت/فروشگاه پس از طی مراحل اداری قابل انجام خواهد بود.</li>
                            <li>کلیه اطلاعات و اسناد ارایه شده باید دارای تاریخ اعتبار باشند ، بدیهی است به مدارک فاقد اعتبار ترتیب اثر داده نخواهد شد.</li>
                        </ul>
                    </div>
                    <div className="mt-2">
                        <strong>نشانی دفتر شركت( شیوه استاندارد نشانی نویسی)</strong>
                        <ul>
                            <li>نشانی با فرمت ( شهر- بزرگراه- بلوار- میدان- خیابان- كوچه- پلاك- طبقه- واحد) مشخص گردد.</li>
                            <li>برای جداسازی كلمات از یکدیگر فقط از علامت (- ) استفاده شود.</li>
                            <li>قبل و بعد از علامت (– ) هیچ گونه فاصله ای قرار داده نشود.</li>
                            <li>از بكار بردن هرگونه كلمات مخفف خودداری شود .</li>
                        </ul>
                    </div>
                    <div className="mt-2">
                        <strong>به روز رسانی اطلاعات تخصصی( بسیار مهم)</strong>
                        <p>
                            جهت به روز رسانی اطلاعات با شماره 3133-058 داخلی 2549 واحد بررسی منابع شركت پتروشیمی خراسان تماس گرفته و پس از اخذ نام كاربری و رمز عبور جدید نسبت به روز آمد نمودن اطلاعات اقدام گردد.
                        </p>
                    </div>

                    <div className="mt-2">
                        <strong>ثبت برند</strong>
                        <ul>
                            <li>نام برند ها فقط به زبان انگلیسی و با حرف بزرگ نوشته شود.</li>
                            <li>برای جداسازی نام برندها فقط از علامت(, ) استفاده شود.</li>
                        </ul>
                    </div>
                    <div className="mt-2">
                        <strong>تذكرات</strong>
                        <p style={{ color: '#c51b2c' }}>
                            با توجه به این كه با نام كاربری و رمز عبور اخذ شده فقط یك بار امكان ثبت در سامانه وجود دارد، لطفا پس از تكمیل فرم و اطمینان از كامل بودن اطلاعات ثبت شده اقدام به زدن دكمه ثبت نمایید. پس از زدن دكمه ثبت امكان ورود به سامانه و ویرایش اطلاعات وجود ندارد.
                        </p>
                    </div>
                    <div className="mt-2">
                        <strong>آپلود مستندات</strong>
                        <p>
                            حجم مستندات از 5MB کمتر باشد.
                        </p>
                        <p style={{ color: '#c51b2c' }}>
                            از پیوست كردن مستندات ناقص و تكراری خودداری شود.
                            قابل توجه کاربران محترم: تا قبل از ثبت نهایی، اطلاعات توسط کارشناسان تدارکات قابل مشاهده نخواهد بود.الزاما باید ثبت نهایی انجام شود.
                        </p>

                    </div>
                </Col>
                <Col xs={12} className="my-2 text-center">
                    <Button variant="success" onClick={(e) => navigate('/register')}>
                        ورود به صفحه ثبت نام
                    </Button>

                </Col>
            </Row>
        </Container>
    )
}